export default {
  bind: (el) => {
    window.addEventListener('resize', () => {
      const { innerHeight } = window;
      const panelHeight = (innerHeight - 40 - 16 - 16 - 12 - 12) / 3;
      el.style.height = `${panelHeight}px`;
    });
  },
  inserted: (el) => {
    const { innerHeight } = window;
    const panelHeight = (innerHeight - 40 - 16 - 16 - 12 - 12) / 3;
    el.style.height = `${panelHeight}px`;
  },
};